export default "__VITE_ASSET__de721991__"